import React from "react";

export type StatusTone =
  | "success"
  | "primary"
  | "danger"
  | "warning"
  | "info"
  | "secondary"
  | "muted";

export type StatusVariant = "text" | "solid";

interface StatusChipProps {
  tone: StatusTone;
  label: React.ReactNode;
  icon?: string;
  variant?: StatusVariant;
  subLabel?: React.ReactNode;
  capitalize?: boolean;
  className?: string;
}

// Each tone maps to its own distinct chip color so two different "positive"
// statuses (e.g. "Sold" vs "On Sale" vs "Approved") are still visually
// distinguishable at a glance.
const toneClass = (tone: StatusTone): string => `statusChip--${tone}`;

const StatusChip: React.FC<StatusChipProps> = ({
  tone,
  label,
  icon,
  subLabel,
  capitalize = false,
  className = "",
}) => {
  const pill = (
    <span
      className={`statusChip ${toneClass(tone)}${
        capitalize ? " text-capitalize" : ""
      }${className ? ` ${className}` : ""}`}
    >
      {icon && <i className={`bi ${icon}`} aria-hidden="true"></i>}
      <span>{label}</span>
    </span>
  );

  if (subLabel !== undefined && subLabel !== null && subLabel !== "") {
    return (
      <div>
        {pill}
        <div className="statusChip__sub">{subLabel}</div>
      </div>
    );
  }

  return pill;
};

export default StatusChip;
